import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Fade,
    Stack,
    Typography,
    alpha,
    useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import CalculateCharges from '../../../../Bookings/Fees/CalculateCharges';
import { formatCurrency } from '../../../../../../shared/utils';

type Props = {
    show: boolean;
    fees: any;
    moduleId: string;
    moduleType: string;
    renderIn?: boolean;
    spaces: any[];
};

export default function FeesSection({
    show,
    fees,
    moduleId,
    moduleType,
    renderIn = true,
    spaces,
}: Props) {
    const theme = useTheme();
    const [chargesExpanded, setChargesExpanded] = useState(false);

    if (!show) return null;

    const total = Number(fees?.bookingTotal?.total) || 0;

    return (
        <Fade in={renderIn} timeout={300}>
            <Box sx={{ width: '100%' }}>
                <Accordion
                    expanded={chargesExpanded}
                    onChange={(_, next) => setChargesExpanded(next)}
                    disableGutters
                    elevation={0}
                    sx={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        borderRadius: 0,
                        boxShadow: 'none',
                        '&:before': { display: 'none' },
                        overflow: 'visible',
                    }}
                >
                    <AccordionSummary
                        expandIcon={
                            <ExpandMoreIcon
                                sx={{
                                    fontSize: 22,
                                }}
                            />
                        }
                        sx={{
                            px: 0,
                            py: 0,
                            minHeight: 44,
                            borderRadius: 1,
                            transition: 'background-color 0.15s ease',
                            '&:hover': {
                                bgcolor: alpha(
                                    theme.palette.primary.main,
                                    0.04,
                                ),
                            },
                            '& .MuiAccordionSummary-content': {
                                my: 0,
                                alignItems: 'center',
                                flexGrow: 1,
                                marginRight: 0.5,
                            },
                            '& .MuiAccordionSummary-expandIconWrapper': {
                                marginLeft: 0,
                            },
                        }}
                    >
                        <Stack
                            direction='row'
                            alignItems='center'
                            justifyContent='space-between'
                            spacing={1}
                            sx={{ width: '100%', pr: 0.5 }}
                        >
                            <Typography
                                component='span'
                                sx={{
                                    fontWeight: 800,
                                    textTransform: 'uppercase',
                                    fontSize: 11,
                                    letterSpacing: 0.9,
                                }}
                            >
                                Total charges
                            </Typography>
                            <Typography
                                component='span'
                                sx={{
                                    fontWeight: 800,
                                    letterSpacing: -0.02,
                                }}
                            >
                                {formatCurrency(total)}
                            </Typography>
                        </Stack>
                    </AccordionSummary>

                    <AccordionDetails
                        sx={{
                            pt: 1.5,
                            px: 0,
                            pb: 0,
                        }}
                    >
                        <CalculateCharges
                            fees={fees}
                            moduleId={moduleId}
                            moduleType={moduleType}
                            spaces={spaces}
                            hideFooterTotal
                        />
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Fade>
    );
}
